import {Chapter} from '../types';
import {ChapterPreset, ChapterPresetResult} from './config';

const cloneWithSkippedFlag = (chapters: Chapter[] | undefined, index: number): Chapter[] | undefined => {
  if (!chapters) return chapters;
  if (index < 0 || index >= chapters.length) return chapters;

  return chapters.map((chapter, idx) =>
    idx === index ? {...chapter, skipped: true} : chapter
  );
};

export const applyChapterPreset = (
  preset: ChapterPreset,
  leftChapters?: Chapter[],
  rightChapters?: Chapter[]
): ChapterPresetResult => {
  if (!preset) {
    return {leftChapters, rightChapters};
  }

  if (preset.type === 'index') {
    const apply = (chapters?: Chapter[]) => cloneWithSkippedFlag(chapters, preset.index);

    switch (preset.side) {
      case 'left':
        return {leftChapters: apply(leftChapters), rightChapters};
      case 'right':
        return {leftChapters, rightChapters: apply(rightChapters)};
      case 'both':
        return {
          leftChapters: apply(leftChapters),
          rightChapters: apply(rightChapters),
        };
      default:
        return {leftChapters, rightChapters};
    }
  }

  return {leftChapters, rightChapters};
};
